export const api_host='https://api-i.atentus.com'
//export const api_host='https://api-ih.atentus.com'

// export const api_host='https://api-i.atentus.com'
export const api_auth='07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2'
export const CLIENTE_ID_PICHINCHA = 5874
export const CLIENTE_ID_BCH = 517 // TODO: clienteId 517 que corresponde al BCH - 1 es para pruebas con Atentus
export const CLIENTE_ID_ATENTUS = 1 // Cliente Atentus: FLINDEX (gráfico Online + pestaña en Configurar objetivos).
export const CLIENTE_ID_MOVISTAR_PERU = 6212

export const atWeb = ["atTransaction Plus 2.0", "atTransaction 2.0", "atTransaction 2.0 CC", "AtTransaction 2.0 con digipass", "atTransaction Plus 2.0 V2", "AtTransaction Plus 2.0 Especial", "AtTransaction Plus 2.0 Digipass Especial"]
export const atIvr = ["AtIVR Monitoreo para centrales IVR"]
export const atMobile = ["AtAppMobile"]
export const atMeta = ["atDns SOA"]
export const API_DISPONIBILIDAD_URL = process.env.REACT_APP_API_DISPONIBILIDAD_URL;
export const DISPONIBILIDAD_SECRET = process.env.REACT_APP_DISPONIBILIDAD;
export const TOKEN_USR_DASHBOARD_PICHINCHA = process.env.REACT_APP_TOKEN_USR_DASHBOARD_PICHINCHA;
export const USR_DASHBOARD_PICHINCHA = process.env.REACT_APP_USR_DASHBOARD_PICHINCHA;
